export default "__VITE_ASSET__f72938be__"